/**
 * Shared shanks-chat helpers — single source of truth for the
 * `shanks-` chatId prefix. URL-routed pages and components both
 * need to detect a shanks-backed chat and lift the bare conversation
 * UUID off the URL; keeping the constant in one place makes a future
 * rename (e.g. dropping the prefix entirely after PR 6) one line of
 * work.
 */ import { generateUUID } from '../utils';
export const SHANKS_CHAT_PREFIX = 'shanks-';
/**
 * Mint a fresh chat id in the canonical `shanks-<uuid>` shape. Single source
 * so the conversation switcher, PromptComposer, and any future new-chat entry
 * points agree on the format.
 */ export function newChatId() {
    return `${SHANKS_CHAT_PREFIX}${generateUUID()}`;
}
/**
 * Strip the shanks- prefix to get the bare conversation UUID that
 * shanks's AgentService.GetConversation / ChatRequest expect. Returns
 * undefined for non-shanks chatIds so callers branch cleanly.
 */ export function shanksConversationId(chatId) {
    if (!chatId || !chatId.startsWith(SHANKS_CHAT_PREFIX)) return undefined;
    return chatId.slice(SHANKS_CHAT_PREFIX.length);
}
